// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__imwQA","footer":"ReportModalFilter_footer__3I5qw"};